import React, { useState, useEffect, useRef } from "react";
import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import { TopBar } from "../../../shared/topBar/TopBar";
import { UrlPath } from "../../../../config/routeConfig";
import { ExistingProformas } from "./existingProformas/ExistingProformas";

export const ProformaConstruction = () => {
  const [loading, setLoading] = useState(true);
  const [selectedOption, setSelectedRadioOption] = useState("existingProforma");  
  useEffect(()=>{
    document.title="Proforma Construction"
  },[])
  let Level = [
    {
      BreadCrumb: "Proforma Construction  ",
      Routes: `${UrlPath.ProformaConstruction}`,
    },
  ];

  Level = loading
    ? Level
    : [
        ...Level,
        {
          BreadCrumb: `Analysis > `,
          Routes: `${UrlPath.ProformaConstruction}`,
        },
        {
          BreadCrumb: `Proforma Construction >`,
          Routes: `${UrlPath.ProformaConstruction}`,
        },
      ];

  const handleRadioChange = (event) => {
    setSelectedRadioOption(event.target.value);
  };

  return (
    <>
      <div id="ProformaConstructionMD" className="mainContentData">
        <TopBar label={"Proforma Construction"} />
        <BreadCrumbs Levels={Level} />
        <div className="p-3 bg-white life-science rounded">
          <div className="col-md-12">
            <label
              htmlFor="table-options"
              className="mb-1 ms-2 fw-semibold fs-12"
            >
              Select
            </label>
            <div className="d-flex align-items-center">
              <div className="form-check">
                <input
                  type="radio"
                  className="form-check-input"
                  name="table-options"
                  id="existingProforma"
                  value="existingProforma"
                  checked={selectedOption === "existingProforma"}
                  onChange={handleRadioChange}
                />
                <label htmlFor="existingProforma" className="form-check-label">
                  Existing Proforma
                </label>
              </div>
              <div className="form-check ms-3">
                <input
                  type="radio"
                  className="form-check-input"
                  name="table-options"
                  id="existingPortfolio"
                  value="existingPortfolio"
                  checked={selectedOption === "existingPortfolio"}
                  onChange={handleRadioChange}
                  disabled
                />
                <label htmlFor="existingPortfolio" className="form-check-label">
                  Existing Portfolio
                </label>
              </div>
            </div>
            <br></br>
          </div>
          {selectedOption === "existingProforma" && <ExistingProformas />}
        </div>
      </div>
    </>
  );
};
